export const LOADED = "zhi-state-loaded";